// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { alphabetNavigationStyles } from "@eisinc/Overrides/Widgets/Brand/AlphabetNavigation";
import Search from "@eisinc/XDL/Icons/Search";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import xScreen from "@eisinc/XDL/Utilities/xScreen";
import { css } from "styled-components";

alphabetNavigationStyles.container = {
    css: css`
        padding: 12px;
        border: 1px solid ${color("common.border")};
        background-color: ${color("common.ui2")};
    `,
};

alphabetNavigationStyles.brandsLettersWrapper = {
    css: css`
        display: flex;
        gap: 24px;

        ${xScreen("lte", "md")} {
            gap: 20px;
        }

        ${xScreen("lt", "sm")} {
            flex-direction: column;
            gap: 24px;
        }
    `,
};

alphabetNavigationStyles.selectWrapper = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            width: 100%;
            display: flex;
        }
    `,
};

alphabetNavigationStyles.select = {
    labelProps: {
        size: fontConfig.regular.size,
        weight: fontConfig.weight.medium,
        lineHeight: fontConfig.singleLineRegular.lineHeight,
        css: css`
            text-transform: none;
        `,
    },
};

alphabetNavigationStyles.alphabetSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

alphabetNavigationStyles.alphabetContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
    `,
};

alphabetNavigationStyles.filterSection = {
    css: css`
        display: flex;
        max-width: 417px;
        width: 100%;

        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

alphabetNavigationStyles.filterInput = {
    iconProps: {
        src: Search,
    },
    labelProps: {
        size: fontConfig.regular.size,
        lineHeight: fontConfig.singleLineRegular.lineHeight,
        weight: fontConfig.weight.medium,
        css: css`
            text-transform: none;
        `,
    },
};

alphabetNavigationStyles.navigationItem = {
    css: css`
        min-width: 22px;
        height: 19px;
        display: flex;
        justify-content: center;
        margin: 0;
        &:not(:last-child)::after {
            content: "";
            display: inline-block;
            margin: 0 9px;
            border-left: 1px solid ${color("text.main")};
            height: 100%;
        }
    `,
};

alphabetNavigationStyles.titleText = {
    variant: "h5",
    ...{ forwardAs: "p" },
};

alphabetNavigationStyles.navigationTextEmpty = {
    transform: "capitalize",
    lineHeight: fontConfig.singleLineRegular.lineHeight,
    size: fontConfig.regular.size,
    color: "text.link",
    css: css`
        display: flex;
        align-items: center;
        opacity: 0.33;
        cursor: not-allowed;
    `,
};

alphabetNavigationStyles.navigationLink = {
    color: "text.link",
    typographyProps: {
        transform: "capitalize",
        size: fontConfig.regular.size,
        lineHeight: fontConfig.singleLineRegular.lineHeight,
        weight: fontConfig.weight.medium,
        css: css`
            letter-spacing: 0.25px;
        `,
    },
};
